<div class="content-create">
  <ul class="content-create-contents">
    <li class="create-section add-client-section">
      <div class="section-label">
        {{ 'CLIENT.NAME' | translate }}
      </div>

      <div
        class="create-section-contents add-client-contents"
        [ngSwitch]="!!docType"
      >
        <app-add-client
          *ngSwitchCase="true"
          class="add-client"
          [billing]="documentBilling"
          [shipping]="documentShipping"
          [enableShipping]="enableShipping"
          [accountSettings]="accountSettings"
          [documentSettings]="documentSettings"
          [enableHandleClickOutside]="true"
          [enableMultipleEmails]="true"
          [actionTriggers$]="addClientActionTriggers$"
          [trackingScreenName]="trackingScreenName"
          [trackingObject]="trackingObject"
          [featureToggles]="featureToggles"
          [locationInfo]="locationInfo$ | async"
          (onEditMode)="onExistingClientEdit($event)"
          (onUpdateClient)="updateClient($event)"
          (onNewClient)="saveClientToList($event)"
          (onDeleteClient)="deleteClient()"
          (onSecondaryAction)="deleteClient()"
          (onGrowthCta)="onGrowthCta.emit()"
        >
        </app-add-client>

        <div *ngSwitchDefault class="placeholder-content placeholder-client">
          <div class="placeholder placeholder-client-name shimmer"></div>

          <div class="placeholder placeholder-client-email shimmer"></div>
        </div>
      </div>
    </li>

    <li
      class="create-section additional-fields-section"
      *ngIf="documentAdditionalFields && !documentAdditionalFields.isEmpty()"
    >
      <div class="section-label">
        {{ 'LABEL.JOB_DETAILS' | translate }}
      </div>

      <div class="create-section-contents additional-fields-contents">
        <app-add-additional-fields
          [additionalFields]="documentAdditionalFields"
          [actionTriggers]="addAdditionalFieldsActionTriggers$"
          (onUpdateAdditionalFields)="updateAdditionalFields($event)"
          (onEditMode)="onExistingAdditionalFieldsEdit($event)"
        >
        </app-add-additional-fields>
      </div>
    </li>

    <li class="create-section document-items-section">
      <div *ngIf="!docType || documentItems?.size === 0" class="section-label">
        <div
          [ngSwitch]="documentSettings?.separatePartsAndLabor"
          class="left-contents"
        >
          <ng-container *ngSwitchCase="true">
            {{ 'LABEL.PARTS_AND_LABOR' | translate }}
          </ng-container>

          <ng-container *ngSwitchDefault>
            {{ 'LABEL.ITEMS' | translate }}
          </ng-container>
        </div>
      </div>

      <ng-container [ngSwitch]="!!docType">
        <ng-container *ngSwitchCase="true">
          <ng-container
            *ngIf="
              (documentSettings?.separatePartsAndLabor &&
                documentItemParts?.size > 0) ||
              (!documentSettings?.separatePartsAndLabor &&
                documentItems?.size > 0)
            "
          >
            <div class="section-label">
              <div
                [ngSwitch]="documentSettings?.separatePartsAndLabor"
                class="left-contents"
              >
                <ng-container
                  *ngSwitchCase="true"
                  [ngSwitch]="documentItemParts?.size === 1"
                >
                  <ng-container *ngSwitchCase="true">
                    {{ 'LABEL.PARTS_ONE_ADDED' | translate }}
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    {{
                      'LABEL.PARTS_N_ADDED'
                        | translate: { numberOfItems: documentItemParts?.size }
                    }}
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngSwitchDefault
                  [ngSwitch]="documentItems?.size === 1"
                >
                  <ng-container *ngSwitchCase="true">
                    {{ 'LABEL.ITEMS_ONE_ADDED' | translate }}
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    {{
                      'LABEL.ITEMS_N_ADDED'
                        | translate: { numberOfItems: documentItems?.size }
                    }}
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <div class="create-section-contents document-items-contents">
              <app-document-items-list
                class="document-items-list"
                [documentItems]="
                  documentSettings?.separatePartsAndLabor
                    ? documentItemParts
                    : documentItems
                "
                [documentDataBuilder]="documentDataBuilder"
                [document]="document$ | async"
                [documentTaxes]="documentTaxes"
                [documentCalculationResult]="documentCalculationResult"
                [documentWithholdingTax]="documentWithholdingTax"
                [documentSettings]="documentSettings"
                [enableDiscount]="enableDiscount"
                [activeItemReferenceId]="activeItemReferenceId"
                [trackingObject]="trackingObject"
                [trackingScreenName]="trackingScreenName"
                [companySettings]="companySettings"
                (onDeleteDocumentItem)="onDeleteDocumentItem($event)"
                (onSaveDocumentItem)="updateDocumentItem($event)"
                (onEditMode)="onDocumentItemEdit($event)"
                (onSaveItemToList)="saveItemToList($event)"
                (onReorderDocumentItem)="onReorderDocumentItem($event)"
              >
              </app-document-items-list>

              <div
                *ngIf="documentSettings?.separatePartsAndLabor"
                class="document-items-subtotal"
              >
                <strong>
                  {{ 'LABEL.PARTS_SUBTOTAL' | translate }}
                </strong>

                <strong>
                  {{
                    documentCalculationResult?.subtotalParts
                      | money
                        : documentSettings.currencyCode
                        : documentSettings.locale
                  }}
                </strong>
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              documentSettings?.separatePartsAndLabor &&
              documentItemLabor?.size > 0
            "
          >
            <div class="section-label">
              <div
                class="left-contents"
                [ngSwitch]="documentItemLabor?.size === 1"
              >
                <ng-container *ngSwitchCase="true">
                  {{ 'LABEL.LABOR_ONE_ADDED' | translate }}
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{
                    'LABEL.LABOR_N_ADDED'
                      | translate: { numberOfItems: documentItemLabor.size }
                  }}
                </ng-container>
              </div>
            </div>

            <div class="create-section-contents document-items-contents">
              <app-document-items-list
                class="document-items-list"
                [documentItems]="documentItemLabor"
                [documentDataBuilder]="documentDataBuilder"
                [document]="document$ | async"
                [documentTaxes]="documentTaxes"
                [documentCalculationResult]="documentCalculationResult"
                [documentWithholdingTax]="documentWithholdingTax"
                [documentSettings]="documentSettings"
                [enableDiscount]="enableDiscount"
                [activeItemReferenceId]="activeItemReferenceId"
                [trackingObject]="trackingObject"
                [trackingScreenName]="trackingScreenName"
                [companySettings]="companySettings"
                (onDeleteDocumentItem)="onDeleteDocumentItem($event)"
                (onSaveDocumentItem)="updateDocumentItem($event)"
                (onEditMode)="onDocumentItemEdit($event)"
                (onSaveItemToList)="saveItemToList($event)"
                (onReorderDocumentItem)="onReorderDocumentItem($event)"
              >
              </app-document-items-list>

              <div class="document-items-subtotal">
                <strong>
                  {{ 'LABEL.LABOR_SUBTOTAL' | translate }}
                </strong>

                <strong>
                  {{
                    documentCalculationResult?.subtotalLabor
                      | money
                        : documentSettings?.currencyCode
                        : documentSettings?.locale
                  }}
                </strong>
              </div>
            </div>
          </ng-container>

          <div class="create-section-contents document-items-contents">
            <app-add-document-items
              *ngIf="mode === ContentCreateModesEnum.add_document_item"
              class="new-document-item"
              [document]="document$ | async"
              [documentTaxes]="documentTaxes"
              [documentWithholdingTax]="documentWithholdingTax"
              [documentDataBuilder]="documentDataBuilder"
              [documentSettings]="documentSettings"
              [companySettings]="companySettings"
              [enableDiscount]="enableDiscount"
              [trackingObject]="trackingObject"
              [trackingScreenName]="trackingScreenName"
              [trackingAdditionalProperties]="trackingAdditionalProperties"
              (saveDocumentItem)="addDocumentItem($event)"
              (saveItemToList)="saveItemToList($event)"
              (chooseMultiple)="openItemPickerDialog()"
              (close)="resetMode()"
            >
            </app-add-document-items>

            <div class="document-items-actions">
              <button
                type="button"
                class="document-items-action add-items-action"
                data-e2e-id="add-items-action"
                [disabled]="atDocumentItemLimit"
                trackable
                [trackingObject]="trackingObject"
                [trackingAction]="addItemsAction"
                [trackingAdditionalProperties]="trackingAdditionalProperties"
                (click)="enterAddItemMode()"
              >
                <div class="add-items-action-content">
                  <app-icon
                    class="add-items-icon"
                    [icon]="addItemsIcon"
                  ></app-icon>

                  {{ 'ACTION.ADD_ITEMS' | translate }}
                </div>
              </button>

              <span class="button-separator"></span>

              <button
                type="button"
                class="document-items-action add-expenses-action"
                [disabled]="atDocumentItemLimit"
                trackable
                [trackingObject]="trackingObject"
                [trackingAction]="addExpensesAction"
                (click)="openExpensePickerDialog()"
              >
                {{ 'ACTION.EXPENSES' | translate }}
              </button>

              <ng-container *ngIf="showTimeTracking">
                <span class="button-separator"></span>

                <button
                  type="button"
                  class="document-items-action add-time-entries-action"
                  [disabled]="atDocumentItemLimit"
                  trackable
                  [trackingObject]="trackingObject"
                  [trackingAction]="addTimeEntriesAction"
                  (click)="
                    openTimeEntriesPickerDialog(EntityTypesEnum.tracked_time)
                  "
                >
                  {{ 'ACTION.TIME_ENTRIES' | translate }}
                </button>
              </ng-container>

              <ng-container *ngIf="showAppointments">
                <span class="button-separator"></span>

                <button
                  type="button"
                  class="document-items-action add-appointments-action"
                  [disabled]="atDocumentItemLimit"
                  trackable
                  [trackingObject]="trackingObject"
                  [trackingAction]="addAppointmentsAction"
                  (click)="
                    openTimeEntriesPickerDialog(EntityTypesEnum.appointment)
                  "
                >
                  {{ 'ACTION.APPOINTMENTS' | translate }}
                </button>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <div
          *ngSwitchDefault
          class="create-section-contents placeholder-content"
        >
          <ul class="placeholder-items">
            <li *ngFor="let i of 3 | fill" class="placeholder-item">
              <div class="left-contents">
                <div
                  class="placeholder placeholder-item-description shimmer"
                ></div>

                <div
                  class="placeholder placeholder-item-quantity-rate shimmer"
                ></div>
              </div>

              <div class="placeholder placeholder-item-total shimmer"></div>
            </li>
          </ul>
        </div>
      </ng-container>
    </li>

    <li *ngIf="docType" class="create-section attachments-section">
      <div class="section-label">
        <div class="left-contents" [ngSwitch]="attachments?.size > 0">
          <ng-container *ngSwitchCase="true">
            {{
              'LABEL.ATTACHMENTS_N_ADDED'
                | translate: { numberOfAttachments: attachments?.size }
            }}
          </ng-container>

          <ng-container *ngSwitchDefault>
            {{ 'LABEL.ATTACHMENTS' | translate }}
          </ng-container>
        </div>
      </div>

      <div class="create-section-contents attachments-contents">
        <app-attachments-list
          [attachments]="attachments"
          [documentType]="documentType"
          [trackingScreenName]="trackingScreenName"
          [trackingObject]="trackingObject"
          (onDeleteAttachmentItem)="onDeleteAttachmentItem($event)"
          (onUpdateAttachmentItem)="onUpdateAttachmentItem($event)"
          (onEditMode)="onExistingAttachmentEdit($event)"
        >
        </app-attachments-list>
      </div>

      <div class="create-section-contents">
        <app-attachments-uploading-list
          *ngIf="attachmentsInProgress$ | async as attachmentsInProgress"
          class="attachments-uploading-list"
          [attachmentsInProgress]="attachmentsInProgress"
          (onCancelAttachment)="onCancelAttachment($event)"
          (onRetryAttachment)="onRetryAttachment($event)"
        >
        </app-attachments-uploading-list>

        <app-add-attachments
          class="add-attachments"
          [label]="'ACTION.ADD_PHOTOS' | translate"
          [checkQuotaAndFeature]="true"
          [icon]="attachmentsIcon"
          [disabled]="atAttachmentLimit"
          [trackingObject]="trackingObject"
          [trackingAction]="addPhotosAction"
          [featureToggles]="featureToggles"
          (onAttachFiles)="onAttachFiles($event)"
          (onGrowthCta)="onGrowthCta.emit()"
        >
        </app-add-attachments>
      </div>
    </li>

    <li class="create-section comments-payment-details-section">
      <div class="section-label" [ngSwitch]="enablePaymentDetails">
        <ng-container *ngSwitchCase="true">
          {{ 'LABEL.COMMENTS_PAYMENT_DETAILS' | translate }}
        </ng-container>

        <ng-container *ngSwitchDefault>
          {{ 'LABEL.COMMENTS' | translate }}
        </ng-container>
      </div>

      <div class="create-section-contents" [ngSwitch]="!!docType">
        <ng-container *ngSwitchCase="true">
          <app-add-note
            class="add-note"
            [note]="documentNote"
            (onNoteChange)="changeNote($event)"
            [trackingObject]="trackingObject"
            [trackingScreenName]="trackingScreenName"
          >
          </app-add-note>

          <app-add-payment-details
            *ngIf="enablePaymentDetails"
            class="add-payment-details"
            [paymentDetails]="documentPaymentDetails"
            (onPaymentDetailsChange)="changePaymentDetails($event)"
            [trackingObject]="trackingObject"
            [trackingScreenName]="trackingScreenName"
          >
          </app-add-payment-details>

          <p
            *ngIf="showPaymentsDetailFooter$ | async"
            class="payment-details-footer"
            [innerHTML]="
              'LABEL.PAYMENT_DETAILS_FOOTER' | translate | safe: 'html'
            "
          ></p>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <div
            class="placeholder-content multi-line-placeholder placeholder-note shimmer"
          ></div>

          <div
            class="placeholder-content multi-line-placeholder placeholder-payment-details shimmer"
          ></div>
        </ng-container>
      </div>
    </li>
  </ul>
</div>

<ng-container *ngIf="document$ | async">
  <app-item-picker-dialog
    [maxItemsAllowed]="maxDocumentItemsAllowed"
    [itemsAdded]="documentItems.size"
    [displayItemType]="documentSettings?.separatePartsAndLabor"
    [trackingScreenName]="trackingScreenName"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    [showProductCode]="documentSettings?.showProductCode"
    [productNameEnabled]="companySettings?.productNameEnabled"
    (onSelectItems)="addItems($event)"
  >
  </app-item-picker-dialog>

  <app-expense-picker-dialog
    [maxExpensesAllowed]="maxDocumentItemsAllowed"
    [expensesAdded]="documentItems.size"
    [maxAttachmentsAllowed]="maxAttachmentsAllowed"
    [attachmentsAdded]="attachments.size"
    [attachmentLimitErrorMessage]="attachmentLimitErrorMessage"
    [trackingScreenName]="trackingScreenName"
    (onSelectExpenses)="addExpenses($event)"
  >
  </app-expense-picker-dialog>

  <app-time-entry-picker-dialog
    [maxItemsAllowed]="maxTimeEntriesAllowed"
    [timeEntryIdsAdded]="documentItemTimeEntryIds$ | async"
    [timeEntryType]="timeEntryPicker$ | async"
    [clientId]="clientId"
    [trackingScreenName]="trackingScreenName"
    (onSelectTimeEntries)="addTimeEntries($event)"
  >
  </app-time-entry-picker-dialog>
</ng-container>

<app-confirm-dialog
  [dialogId]="confirmDeleteTrackedTimeId"
  [confirmTitle]="'TRACKED_TIME.DELETE_ITEM.CONFIRM_TITLE' | translate"
  [confirmPrompt]="'TRACKED_TIME.DELETE_ITEM.CONFIRM_PROMPT' | translate"
  [cancelText]="'ACTION.CANCEL' | translate"
  [yesText]="'ACTION.PROCEED' | translate"
  [isDeleteAction]="true"
  [trackingObject]="trackingObject"
  [primaryActionTapped]="deletedTrackedTimeAction"
  (onClose)="onConfirmDeleteDocumentItem($event)"
>
</app-confirm-dialog>

<app-confirm-dialog
  [dialogId]="confirmDeleteAppointmentId"
  [confirmTitle]="'APPOINTMENT.DELETE_ITEM.CONFIRM_TITLE' | translate"
  [confirmPrompt]="'APPOINTMENT.DELETE_ITEM.CONFIRM_PROMPT' | translate"
  [cancelText]="'ACTION.CANCEL' | translate"
  [yesText]="'ACTION.PROCEED' | translate"
  [isDeleteAction]="true"
  [trackingObject]="trackingObject"
  [primaryActionTapped]="deletedAppointmentAction"
  (onClose)="onConfirmDeleteDocumentItem($event)"
>
</app-confirm-dialog>

<!--TODO: [ADD-MOBILE-FILED] delete DIALOG.UPDATE_CLIENT_EMAIL part in en-US.json after the feature is live-->
<app-confirm-dialog
  [dialogId]="confirmUpdateClientId"
  [confirmTitle]="'DIALOG.UPDATE_CLIENT.CONFIRM_TITLE' | translate"
  [cancelText]="'ACTION.NO_THANKS' | translate"
  [yesText]="'ACTION.YES' | translate"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="TrackingDialogNamesEnum.update_client_data"
  (onClose)="onConfirmUpdateClientEmail($event)"
>
</app-confirm-dialog>
